exports.install = function(Vue,options){
    // 参数：method（url），data（请求参数对象）
    Vue.prototype.jsonp = function(method,data){
        // baseUrl就是服务器地址
        let url = `${method}?`;
        // jsonp请求参数和get方法类似，都是params的方式拼接
        let index = 0;
        for(let item in data){
            if(index == 0){
                url += `${item}=${data[item]}`;
            }else{
                url += `&${item}=${data[item]}`;
            }
            index = index + 1 ;
        }
        return this.$jsonp(url);
    };
}